import { ChevronLeft } from "lucide-react"
import type { FC } from "react"
import { Link, Outlet, useLocation } from "react-router"
import { Button } from "@/components/ui/button"
import { LOGIN_PAGE_CONFIG } from "@/lib/login-page-config"
import { cn } from "@/lib/utils"

export const LoginLayout: FC = () => {
  const location = useLocation()
  const pageConfig = LOGIN_PAGE_CONFIG[location.pathname]

  const {
    title,
    description,
    backTo,
    maxWidthClassName = "max-w-[425px]",
    contentClassName,
    headingClassName,
    descriptionClassName,
  } = pageConfig

  return (
    <section className={cn("mx-auto w-full", maxWidthClassName)}>
      <div className="relative flex h-[76px] items-center justify-center px-4 pb-3 pt-5">
        {backTo ? (
          <div className="absolute bottom-3 left-1 top-5 flex items-center">
            <Button
              asChild
              type="button"
              variant="ghost"
              size="icon"
              className="size-9 rounded-full bg-white/80 text-text backdrop-blur-[10px] hover:bg-white"
            >
              <Link to={backTo} aria-label="back">
                <ChevronLeft className="size-5" strokeWidth={2.25} />
              </Link>
            </Button>
          </div>
        ) : null}
        <h1
          className={cn(
            "text-center text-[18px] font-semibold leading-[1.35] text-foreground",
            headingClassName
          )}
        >
          {title}
        </h1>
      </div>

      <div className="px-4 pt-3">
        <div className={cn("mx-auto w-full max-w-[393px]", contentClassName)}>
          {description ? (
            <div
              className={cn(
                "mb-10 text-[14px] font-normal leading-[1.5] text-gray",
                descriptionClassName
              )}
            >
              {description}
            </div>
          ) : null}
          <Outlet />
        </div>
      </div>
    </section>
  )
}
